import { Children, cloneElement, isValidElement, useId } from "react";

const NATIVOS = ["input", "select", "textarea", "button"];

// Asocia una etiqueta visible con su campo (WCAG 1.3.1, 3.3.2, 4.1.2):
//   <Campo><label>Texto</label><input/></Campo>
// - Campo nativo (input, select, textarea, button): htmlFor en la etiqueta e id
//   en el campo (el suyo, si ya lo tenia).
// - Grupo (un div con botones, como los selectores de color): la etiqueta recibe
//   un id y el div role="group" y aria-labelledby.
// - Componente propio (DatePicker, HoursInput...): recibe id y aria-labelledby
//   y los pasa a su control.
// No pinta nada propio: es un Fragment, asi que el maquetado no cambia.
export default function Campo({ children }) {
  const auto = useId();
  const hijos = Children.toArray(children);
  const iEt = hijos.findIndex(h => isValidElement(h) && h.type === "label");
  const iCampo = hijos.findIndex((h, i) => i > iEt && isValidElement(h));
  if (iEt < 0 || iCampo < 0) return <>{hijos}</>;
  const campo = hijos[iCampo];
  const id = campo.props.id || auto;
  const idEt = auto + "-et";
  const nativo = typeof campo.type === "string" && NATIVOS.includes(campo.type);
  const grupo = typeof campo.type === "string" && !nativo;
  return (
    <>
      {hijos.map((h, i) => {
        if (i === iEt) return cloneElement(h, nativo ? { htmlFor: id } : { id: idEt });
        if (i !== iCampo) return h;
        if (nativo) return cloneElement(h, { id });
        if (grupo) return cloneElement(h, { role: "group", "aria-labelledby": idEt });
        return cloneElement(h, { id, "aria-labelledby": idEt });
      })}
    </>
  );
}
